import React from 'react'

import { Text } from '@chakra-ui/react'
import { Box, Stack, Flex } from '@pnld/components-web'

import { LegendProps } from './types'

const PieChartLegend = ({ payload, direction = 'row' }: LegendProps) => {
  return (
    <Stack
      direction={direction}
      justify="center"
      flexWrap={direction === 'row' ? 'wrap' : 'nowrap'}
      gap={direction === 'row' ? 3 : 2}
    >
      {payload?.map((item: any, index: number) => {
        const formattedValue = new Intl.NumberFormat('pt-BR').format(
          item.payload?.value ?? 0
        )

        return (
          <Flex key={`pie-item-${index}`} gap={2} align="center">
            <Box minH="16px" minW="16px" bg={item.color} borderRadius="full" />
            <Text fontWeight="semibold" fontSize="14px" whiteSpace="nowrap">
              {item.value} | {formattedValue}
            </Text>
          </Flex>
        )
      })}
    </Stack>
  )
}

export default PieChartLegend
